/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'CardsContainerBlock';
const CLS = 'cardsContainerBlock';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/cardsContainerBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import * as Api from '../api';
import Handlebars from 'handlebars';

export class CardsContainerBlock {
	constructor($el) {
		// $el is the widget node return by the loadCardsContainerBlock function
		this.$el = $el;
	}

	init() {
		const This = this;
		const $wg = $(this.$el);
		This.page = 0;
		This.loadingSpinner = $('.loading-spinner');
		This.cardsList = $wg.find(`${WG}cards`);
		This.loadMore = $wg.find(`${WG}loadMore`);
		this.setCardItem();
		this.setCardsContainerBlock();
	}

	setCardsContainerBlock() {
		// Add Some logic here
		const This = this;
		const $wg = $(this.$el);

		$wg.on('click', `${WG}loadMore button`, function() {
			This.getItems();
		});

		// get items on load
		This.getItems();
	}

	getItems() {
		const This = this;

		// increment page
		This.page++;

		// show spinner
		This.loadingSpinner.addClass('is-active');

		This.getItemsCall().then(function(data) {
			let hasMore = data.hasMore;
			let items = data.items;
			if (items.length > 0) {
				for (let i = 0; i < items.length; i++) {
					let item = items[i];
					let itemHtml = This.cardBlockItemTemplate(item);
					// append to the cards list
					This.cardsList.append(`
						<div class="col-12 col-sm-6 col-lg-4 ${CLS}-cardWrapper">
							${itemHtml}
						</div>
					`);
				}
			} else {
				// no items
				This.cardsList.html(`
					<div class="col-12">
					<p>Sorry, no items were found.</p>
					</div>
				`);
			}
			// check if hasMore
			if (hasMore) {
				This.loadMore.removeClass('d-none');
			} else {
				This.loadMore.addClass('d-none');
			}
			// remove loading spinner
			This.loadingSpinner.removeClass('is-active');
		}, function(err) {
			This.loadingSpinner.removeClass('is-active');
		});
	}

	getItemsCall() {
		const This = this;
		const $wg = $(this.$el);
		let endpoint = $wg.data('getItemsEndpoint');
		return Api.getApi(endpoint + `?pageSize=6&pageNum=${This.page}`);
	}

	setCardItem() {
		const This = this;
		let partial = require('../../partials/widgets/cardItemBlock.hbs');
		Handlebars.registerPartial('cardItemBlock', partial);
		let template = `
			{{> cardItemBlock
				wg="cardItemBlock"
				ns="CardItemBlock"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		This.cardBlockItemTemplate = Handlebars.template(precompiled);
	}

	// Add more functions like on above here
}
